<template>
    <div>
        <div class="input-container ">
            <label for="family-nome">{{label}}</label>
            <div class="attachments-list">
                <div v-for="(attachment, index) in attachments" :key="index" class="attachment">
                    <div
                        v-if="attachment.thumbnailUrl"
                        class="image content"
                        @click="onClickDetails(attachment)"
                        :style="{ backgroundImage: 'url(' + attachment.thumbnailUrl + ')'}"
                    ></div>
                    <div
                        v-else-if="attachment.fileName.toLowerCase().indexOf('.png') != -1 || attachment.fileName.toLowerCase().indexOf('.jpg') != -1"
                        class="image content"
                        @click="onClickDetails(attachment)"
                        :style="{ backgroundImage: 'url(' + attachment.url + '&disposition=inline)'}"
                    ></div>
                    <div v-else class="file content" @click="onClickDetails(attachment)" target="_blank">
                        <i class="fas fa-file"></i>
                    </div>

                    <div class="attachment-data">{{attachment.FileName}}</div>
                    <div class="attachment-tools">
                        <a v-if="displayWatch" :href="attachment.url + '&disposition=inline'" target="_blank" class="tool">
                            <i class="fa fa-eye"></i>
                        </a>
                        <a v-if="displayDownload" :href="attachment.url + '&disposition=attachment'" class="tool">
                            <i class="fa fa-download"></i>
                        </a>
                        <a v-if="displayMove && !readOnly" @click="onMoveLeft(index)" v-show="index > 0" class="attachment-move tool">
                            <i class="fas fa-caret-left"></i>
                        </a>
                        <a
                            v-if="displayMove && !readOnly"
                            @click="onMoveRight(index)"
                            v-show="index < attachments.length - 1"
                            class="attachment-move tool"
                        >
                            <i class="fas fa-caret-right"></i>
                        </a>
                        <a v-if="!readOnly" @click="removeAttachment(index)" class="attachment-remove tool">
                            <i class="fa fa-trash"></i>
                        </a>
                    </div>
                </div>
                
                <input ref="fileInput" @change="onFileChange" type="file" name="file" class="file-input">
                <div
                    @click.prevent="onClickRestart"
                    ref="form"
                    v-show="!readOnly && (maxAttachments == 0 || attachments.length < maxAttachments)"
                    enctype="multipart/form-data"
                    class="box js has-advanced-upload attachment"
                >
                    <input type="hidden" name="ajax" v-model="isAjax" >
                    
                    <div>
                        <div v-if="loading">Caricamento....</div>
                        <div v-else-if="error">
                            <strong>Errore: </strong> {{this.errorText}}
                        </div>
                        <div v-else class="text">
                            Seleziona un file o trascinalo qui.
                        </div>
                    </div>
                    
                    <div v-if="options" class="info">
                        <div v-if="options.maxSize">Dimensione (max): {{options.maxSize | prettyBytes}}</div>
                        <div v-if="options.extensions && options.extensions.length > 0">
                            Estensioni:
                            <strong>
                                <span
                                    v-for="(ext, index) in options.extensions"
                                    :key="index"
                                >{{ext}}</span>
                            </strong>
                        </div>
                        <div v-if="options.width">Larghezza: <strong>{{options.width}} px</strong></div>
                        <div v-if="options.height">Altezza: <strong>{{options.height}} px</strong></div>
                    </div>
                </div>
            </div>
            <ul class="parsley-errors-list filled" id="parsley-id-18"
                v-if="errors && errors.length > 0">
                <li v-for="(error, index) in errors" :key="index" 
                    class="parsley-required">{{error}}</li>
            </ul>            
        </div>
    </div>
</template>

<script>
import MediaLibraryAPI from "@/service/MediaLibraryAPI"
import PrettyBytes from "@/filters/PrettyBytes"

export default {
	filters: {
		PrettyBytes
	},
	props: {
		label: String,
		required: Boolean,
		errors: Array,
		displayMove: {
			type: Boolean,
			default: true
		},
		displayWatch: {
			type: Boolean,
			default: true
		},
		displayDownload: {
			type: Boolean,
			default: true
		},
		readOnly: {
			type: Boolean,
			default: false
		},
		maxAttachments: {
			type: Number,
			default: 0
		},
		value: {
			type: Array
		},
		options: {
			type: Object,
			default() {
				return {};
			}
		}
	},
	data() {
		return {
			loading: false,
			error: false,
			errorText: "",
			isAjax: false,
			droppedFiles: null,
			files: null,
			attachments: []
		};
	},
	computed: {},
	watch: {
		attachments: {
			handler() {
				this.$emit('input', this.attachments)
			},
			deep: true
		}
	},
	mounted: function() {     
		this.attachments = this.value
		
		if (!this.attachments){
			this.attachments = []
		}

		this.createUploader()
	},
	methods: {
		onClickRestart: function() {
			this.error = false
			this.loading = false
			this.files = null

			this.$refs.fileInput.value = ''
			this.$refs.fileInput.click()
		},
		removeAttachment: function(index) {
			if (!confirm("Rimuovere allegato?")) {
				return;
			}

			this.attachments.splice(index, 1);
		},
		isAdvancedUpload() {
			var div = document.createElement("div");
			return (
				("draggable" in div ||
					("ondragstart" in div && "ondrop" in div)) &&
				"FormData" in window &&
				"FileReader" in window
			);
		},
		checkFileExtension(fileName) {
			if (!this.options || !this.options.extensions || this.options.extensions.length == 0 || !fileName) {
				return true;
			}

			var extension = fileName
				.substring(fileName.lastIndexOf(".") + 1)
				.toLowerCase()
				.trim();
			if (this.options.extensions.indexOf(extension) === -1) {
				return false;
			}
			return true;
		},
		checkFileMaxSize(size){
			if (!this.options || !this.options.maxSize){
				return true;
			}

			return size <= this.options.maxSize;
		},
		checkImageSize(file){
			var _this = this;
			return new Promise((resolve, reject) => {
				if (!this.options || !(this.options.width && this.options.height)){
					resolve (true);
				}

				var img = new Image();
				img.src = window.URL.createObjectURL( file );

				img.onload = function() {
					var width = img.naturalWidth;
					var height = img.naturalHeight;

					window.URL.revokeObjectURL( img.src );

					if( width == _this.options.width && height == _this.options.height ) {
						resolve(true);
					} else {
						resolve(false);
					}
				};
			});
		},
		onFileChange (){
			this.files = this.$refs.fileInput.files;
			this.onFormSubmit();
		},
		onFormSubmit: async function() {
			var _this = this;

			// preventing the duplicate submissions if the current one is in progress
			if (this.loading) {
				return false;
			}

			this.error = false;
			this.loading = true;

			if (_this.isAdvancedUpload()) {
				let f = document.createElement("form");
				let ajaxData = new FormData(f);
				
				for (let i = 0; i < this.files.length; i++) {
					let file = this.files[i];
					ajaxData.append("files", file);
					
					if (!this.checkFileExtension(file.name)) {
						alert("Formato file non valido.");
						_this.loading = false;
						return;
					}
					if (!this.checkFileMaxSize(file.size)){
						alert("Dimensione del file non valida.");
						_this.loading = false;
						return;
					}

					let checkSize = await this.checkImageSize(file);
					if (!checkSize){
						alert("Dimensioni immagine non valide.");
						_this.loading = false;
						return;
					}
				}
				
				try{
					await MediaLibraryAPI.getToken()
					
					var ajax = new XMLHttpRequest();
					ajax.open("post", MediaLibraryAPI.buildUrl('/api/v2/medialibrary/MlAttachmentEntity'), true);
					ajax.setRequestHeader("Authorization", "bearer " + MediaLibraryAPI.token)
					ajax.onprogress = function(e) {
						if (e.lengthComputable) {
							//console.log(e.loaded + " / " + e.total);
						}
					};

					ajax.onload = function() {
						_this.loading = false;

						if (ajax.status >= 200 && ajax.status < 400) {
							var data = JSON.parse(ajax.responseText);
							
							_this.error = data.hasErrors;
							if (_this.error) {
								_this.errorText = data.message;
							} else {
								_this.attachments.push(data.attachment);
							}
						} else {
							alert("Error. Please, contact the webmaster!");
						}
					};

					ajax.onerror = function() {
						_this.loading = false;
						alert("Error. Please, try again!");
					};

					ajax.send(ajaxData);
				} catch (ex){
					console.log(ex)
				}
			} else {
				this.HasErrors = true;
				this.error = "Componente non supportato dal browser.";
			}

			return false;
		},
		createUploader: function() {
			if (this.readOnly) {
				return;
			}

			var _this = this;
			this.error = false;
			this.loading = false;
			this.isAjax = true;

			var input = this.$refs["fileInput"];
			var form = this.$refs["form"];
			var triggerFormSubmit = function() {
				_this.onFormSubmit();
			};

			// drag&drop files if the feature is available
			if (this.isAdvancedUpload()) {
				[
					"drag",
					"dragstart",
					"dragend",
					"dragover",
					"dragenter",
					"dragleave",
					"drop"
				].forEach(function(event) {
					form.addEventListener(event, function(e) {
						// preventing the unwanted behaviours
						e.preventDefault();
						e.stopPropagation();
					});
				});
				["dragover", "dragenter"].forEach(function(event) {
					form.addEventListener(event, function() {
						form.classList.add("is-dragover");
					});
				});
				["dragleave", "dragend", "drop"].forEach(function(event) {
					form.addEventListener(event, function() {
						form.classList.remove("is-dragover");
					});
				});

				form.addEventListener("drop", function(e) {
					_this.files = e.dataTransfer.files;
					triggerFormSubmit();
				});
			}

			// Firefox focus bug fix for file input
			input.addEventListener("focus", function() {
				input.classList.add("has-focus");
			});
			input.addEventListener("blur", function() {
				input.classList.remove("has-focus");
			});
		},
		onClickDetails: function() {
			
		},
		onMoveLeft: function(index) {
			var tmp = this.attachments[index - 1];
			this.attachments[index - 1] = this.attachments[index];
			this.attachments[index] = tmp;
			this.$forceUpdate();

			this.$emit('input', this.attachments)
		},
		onMoveRight: function(index) {
			var tmp = this.attachments[index + 1];
			this.attachments[index + 1] = this.attachments[index];
			this.attachments[index] = tmp;
			this.$forceUpdate();

			this.$emit('input', this.attachments)
		}
	}
}
</script>

<style scoped>
.box {
	cursor: pointer;
    background-color: #d8eaef;
    position: relative;
    padding: 15px 17px;
    text-align: center;
}
.box.has-advanced-upload {
	outline: 2px dashed #92b0b3;
	outline-offset: -10px;
	-webkit-transition: outline-offset 0.15s ease-in-out,
		background-color 0.15s linear;
	transition: outline-offset 0.15s ease-in-out, background-color 0.15s linear;
}
.box.is-dragover {
	outline-offset: -20px;
	outline-color: #c8dadf;
	background-color: #fff;
}
.box__dragndrop,
.box__icon {
	display: none;
}
.box.has-advanced-upload .box__dragndrop {
	display: inline;
}
.box.has-advanced-upload .box__icon {
	width: 100%;
	height: 80px;
	fill: #92b0b3;
	display: block;
	margin-bottom: 40px;
}

.box__uploading {
	font-style: italic;
}
@-webkit-keyframes appear-from-inside {
	from {
		-webkit-transform: translateY(-50%) scale(0);
	}
	75% {
		-webkit-transform: translateY(-50%) scale(1.1);
	}
	to {
		-webkit-transform: translateY(-50%) scale(1);
	}
}

@keyframes appear-from-inside {
	from {
		transform: translateY(-50%) scale(0);
	}
	75% {
		transform: translateY(-50%) scale(1.1);
	}
	to {
		transform: translateY(-50%) scale(1);
	}
}

.box__restart {
	font-weight: 700;
}
.box__restart:focus,
.box__restart:hover {
	color: #39bfd3;
}

.file-input {
	width: 0.1px;
	height: 0.1px;
	opacity: 0;
	overflow: hidden;
	position: absolute;
	z-index: -1;
}

.js .box__file + label:hover strong,
.box__file:focus + label strong,
.box__file.has-focus + label strong {
	color: #39bfd3;
}
.js .box__file:focus + label,
.js .box__file.has-focus + label {
	outline: 1px dotted #000;
	outline: -webkit-focus-ring-color auto 5px;
}

.no-js .box__button {
	display: block;
}
.box__button {
	font-weight: 700;
	color: #e5edf1;
	background-color: #39bfd3;
	display: none;
	padding: 8px 16px;
	margin: 40px auto 0;
}
.box__button:hover,
.box__button:focus {
	background-color: #0f3c4b;
}
.text{ 
	padding: 15px 0px 15px 0px;
}
.attachment {
	display: inline-block;
	width: 100%;
	border: 1px solid black;
	margin: 5px;
	position: relative;
	text-align: center;
	vertical-align: top;
}
.attachment .image {
	width: 100%;
	height: 168px;
	display: block;
	background-size: contain;
	background-repeat: no-repeat;
	background-position-x: center;
}
.attachment .file {
	width: 100%;
	height: 128px;
	position: relative;
	font-size: 5rem;
	color: green;
	padding: 20px;
	display: block;
}
.attachment .file i {
	position: absolute;
	top: 39px;
	left: 44px;
	font-size: 6rem;
}
.attachment-data {
	padding: 5px;
    font-size: 0.8rem;
    position: absolute;
    bottom: 0px;
    background-color: rgb(240, 240, 240, 0.7);
    overflow: hidden;
    width: 100%;
    text-overflow: ellipsis;
}
.attachment-tools {
	position: absolute;
	top: 5px;
	right: 5px;
	padding: 8px;
	background-color: rgba(100, 100, 100, 0.5);
}
.attachment-move {
	cursor: pointer;
}
.attachment-remove {
	color: red;
	cursor: pointer;
}
.disabled {
	cursor: default;
}
.tool {
	cursor: pointer;
	width: 23px;
	display: inline-block;
	margin-right: 5px;
}
.tool:hover {
	color: #eeeeee !important;
}
.content {
	cursor: pointer;
}
.info {
	font-size: 0.8rem;
}
</style>